export default "__VITE_ASSET__cee8f547__"